import { defineComponent as _defineComponent } from 'vue'


export type ManuscriptListItem = {
    manuscriptKey: string;
    title: string;
    issueCount?: number;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ManuscriptList',
  props: {
    manuscripts: { type: Array, required: true },
    activeManuscriptKey: { type: String, required: false }
  },
  emits: ["manuscript-click"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'manuscript-click', manuscriptKey: string): void;
}), expose: any, slots: any, attrs: any }) {





function onClickManuscript(manuscriptKey: string) {
    emit('manuscript-click', manuscriptKey);
}

return { __sfc: true,emit, onClickManuscript }
}

})